import { Component, OnInit } from '@angular/core';
import { RootService } from '../../service/root.service';
import { FAuth } from '../shared/fAuth';

import { ActivatedRoute, Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
declare var lbd: any;
@Component({

    selector: 'auth-change-password',
    templateUrl: './auth-change-password.component.html',
    styleUrls: ['./auth-change-password.component.scss']
})
export class AuthChangePasswordComponent implements OnInit {
    fAuth = new FAuth();
    user;
    hash;
    id;
    constructor(public rootService: RootService, private translate: TranslateService, private route: ActivatedRoute,
        private router: Router, ) {
        this.user = null;
    }
    submittingForm: boolean = false;

    ngOnInit() {
        lbd.checkFullPageBackgroundImage();

        setTimeout(function () {
            // after 1000 ms we add the class animated to the login/register card
            $('.card').removeClass('card-hidden');
        }, 200)
        this.hash = this.router['currentUrlTree']['queryParams']['hash'];

        this.route.params.subscribe(params => {

            this.id = params['id'];


        });
    }
    onSubmit(form) {
        this.fAuth['hash'] = this.hash;
        this.fAuth['id'] = +this.id;
        if (this.submittingForm) {
            return;
        }
        this.submittingForm = true;
        this.rootService.changePassword(this.fAuth).subscribe(item => {
            this.rootService.toast.showSuccess(this.translate.instant('auth.common.changePasswordM'));
            this.submittingForm = false;
        }, err => {
            this.rootService.toast.showErrorCode(err.code);
            this.submittingForm = false;
        });;
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/auth-change-password/auth-change-password.component.ts